module.exports = __webpack_public_path__ + "static/media/blank_copy.29aafcad.pdf";